import nbsAxiosInstance from './axiosInstances/nbsAxiosInstance';

import store from '../../store/store';
import { removeSessionToken } from '../../store/actions/session';
import { nbsWSClose } from '../../store/actions/socket';
import {
  deleteReduxStateFromStorage,
  getSessionTokenFromCookie,
} from './utils';

const apiWithoutSessionToken = [
  'getConfig',
  'signup',
  'login',
  'checkUsername',
  'checkFirstName',
  'confirmEmail',
  'forgotPassword',
  'checkAccountExists',
  'setNewPassword',
  'trackAffiliateClick',
  'myLocation',
  'unsubscribeEmail',
  'resubscribeEmail',
  'addUnsubscribeReason',
  'searchLocation',
  'transCoregLookup',
  // deleteAccount and deactivateAccount is special so will need to add here,
  // because we are listening them on the homepage for the alert message to show
  // TODO refactor it.
  'deleteAccount',
  'deactivateAccount',
];

function recurseAttribute(data) {
  if (typeof data === 'object' && data !== null) {
    let newData = {};
    for (let key in data) {
      if (typeof data === 'object' && data !== null) {
        recurseAttribute(data[key]);
      } else if (
        data[key] !== undefined &&
        data[key] !== null &&
        data[key] !== ''
      ) {
        newData.append(key, data[key]);
      }
    }
    return newData;
  }
  return data;
}

export default async function nbsApi(command, data, axiosConfig = {}) {
  const formData = new FormData();

  // console.log('NBS API command:::::::', command);
  // console.log('NBS API REQUEST::::::::', data);

  for (let key in data) {
    if (
      !apiWithoutSessionToken.includes(command) &&
      data.sess_token !== getSessionTokenFromCookie()
    ) {
      nbsWSClose();
      store.dispatch(removeSessionToken());
      deleteReduxStateFromStorage();
      return;
    }
    if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
      if (command === 'uploadImage' || command === 'uploadImageToCDN') {
        formData.append(key, data[key]);
      } else {
        formData.append(key, recurseAttribute(data[key]));
      }
    }
  }

  const result = await nbsAxiosInstance({
    ...axiosConfig,
    url: command,
    data: formData,
  });
  // console.log('NBS API RESULT::::::::', result);
  if (result.data.success) {
    return result.data;
  } else {
    throw new Error('NBS API Error', { cause: result.data });
  }
}
